import React from 'react'
import { Link } from 'gatsby'
import styles from './localizedBreadCrumb.module.scss'

const Item = ({ link, display }: Item) =>
  link ? (
    <Link className={styles.link} to={link}>
      {display}
    </Link>
  ) : (
    <span className={styles.link}>{display}</span>
  )

interface Item {
  link?: string
  display: string
}
export type BreadCrumbItems = Item[]

interface Props {
  items: Item[]
}

const site = process.env.GATSBY_WEB


const LocalizedBreadcrumbItems = ({ items }: Props) => (
  <div className={site == 'rodi' ? `${styles.breadCrumb} ${styles.rodi}` : styles.breadCrumb}>
    <div className={styles.breadCrumbText}>
      {items
        .map((item, index) => (
          <Item key={index} link={item.link} display={item.display} />
        ))
        .reduce((a, b) => [a, '>', b] as any)}
    </div>
  </div>
)

export default LocalizedBreadcrumbItems
